import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';

import { KeyPersonsService } from '../../services/key-persons.service';

@Component({
  selector: 'app-display-key-persons',
  templateUrl: './display-key-persons.component.html',
  styleUrls: ['./display-key-persons.component.css']
})
export class DisplayKeyPersonsComponent implements OnInit, OnDestroy {

  id: string;
  parent: string;
  customerOrSupplier: string;

  keyPerson: any;
	keyPerson$: Observable<any>;
	keyPersonSub: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private keyPersonsService: KeyPersonsService
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
    this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];

    this.keyPerson$ = this.keyPersonsService.getKeyPerson(this.id);
    this.keyPersonSub = this.keyPerson$.subscribe(data => {
      this.keyPerson = {
        name: data.name,
        lastName: data.lastName,
        job: data.job,
        phone: data.phone,
        email: data.email
      };
    });
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.keyPersonSub.unsubscribe();
  }
  getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/keyPersons']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/keyPersons']);
		}
	}

}
